/**
 * Maintains global messages such as the broadcast
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Broadcast from '../../components/spaden/molecules/Broadcast';
import { removeBroadcast } from '../../actions/globalBroadcastActions';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const TRANSITION_OPTIONS = {
    appear: true,
    timeout: { enter: 400, exit: 400 },
    classNames: 'smack-down',
};
export class GlobalMessages extends Component {
    static propTypes = {
        message: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
    };

    onRemoveBroadcast = () => {
        this.props.dispatch(removeBroadcast());
    };

    render() {
        const { message } = this.props;

        return (
            <TransitionGroup>
                {Boolean(message) && (
                    <CSSTransition {...TRANSITION_OPTIONS}>
                        <Broadcast
                            className="pam bat border-watermelon bg-salmon cherry"
                            onRemove={this.onRemoveBroadcast}
                        >
                            <span className="caption showbydefault mls">
                                {message}
                            </span>
                        </Broadcast>
                    </CSSTransition>
                )}
            </TransitionGroup>
        );
    }
}

export default connect((state) => ({ message: state.globalBroadcast.message }))(
    GlobalMessages
);
